import { createCustomEnum } from "./customEnum";

const SourceFileImportStatuses = createCustomEnum({
	Pending: {
		value: 0,
		name: "pending",
		displayName: "Import pending",
	},
	InProgress: {
		value: 1,
		name: "inProgress",
		displayName: "Import in progress",
	},
	Completed: {
		value: 2,
		name: "complete",
		displayName: "Import completed",
	},
	Failed: {
		value: 3,
		name: "failed",
		displayName: "Import failed",
	},
});

export default SourceFileImportStatuses;
